/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Suspense } from "react";
import { Loader, theme } from "@nordcloud/gnui";
import type { AutocompleteUiBaseProps } from "./AutocompleteUi";
import { AutocompleteUi } from "./AutocompleteUiLazy";

type InputProps = {
  value?: string;
  onChange: (value: string) => void;
  onSelect: (value: string) => void;
  placeholder?: string;
};

type Props = AutocompleteUiBaseProps & InputProps;

export function Autocomplete({
  value,
  onChange,
  onSelect,
  placeholder,
  ...props
}: Props) {
  return (
    <Suspense
      fallback={
        <div
          css={{
            width: "100%",
            paddingTop: theme.spacing.spacing04,
            paddingBottom: theme.spacing.spacing04,
          }}
        >
          <Loader inContent />
        </div>
      }
    >
      <AutocompleteUi
        placeholder={placeholder}
        useComboboxProps={{
          items: props.items,
          onInputValueChange: ({ inputValue = "" }) => {
            onChange(inputValue);
          },
          onSelectedItemChange: ({ selectedItem }) => {
            if (selectedItem != null) {
              onSelect(selectedItem);
            }
          },
          inputValue: value,
        }}
        {...props}
      />
    </Suspense>
  );
}
